import Layout from '@/framework/layout';
export default [
    {
        code: 'iov:dataService',
        path: '/dataService',
        name: 'DataService',
        alwaysShow: true,
        component: Layout,
        redirect: 'VehicleModelConfig',
        meta: { title: '数据服务', elSvgIcon: 'Fold' },
        children: [
            {
                code: 'iov:vehicleModelConfig',
                path: '/vehicleModelConfig',
                name: 'VehicleModelConfig',
                meta: { title: '车型码配置', cachePage: true },
                // component: () => import('@/framework/serviceView/dataService/vehicleModelConfigPage.vue'),
                component: () => import('@/framework/serviceView/dataService/vehicleModelConfigPageNew.vue'),
                children: [
                   
                ]
               
            },

        ]
    },
];
